export default __webpack_public_path__ + "static/media/iphone-mobile.34f7a5fb.png";